import { columnDateField, columnTextField } from "utils/tables-utils";
import {
  Card,
  CardContent,
  Chip,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import LoadingData from "components/Loading/LoadingData";
import TableComponent from "components/_refactor/table/table";
import { FileDownload, FileDownloadOff } from "@mui/icons-material";

const getColumnModel = () => [
  columnDateField({
    dataField: "DataRecebimento",
    text: "Criado em",
  }),
  columnTextField({
    dataField: "Periodo",
    text: "Período",
    align: "center",
  }),
  columnDateField({
    dataField: "DataVencimento",
    text: "Vencimento em",
  }),
  columnTextField({
    dataField: "NomeCliente",
    text: "Nome do Cliente",
    align: "center",
  }),
  columnTextField({
    dataField: "Status",
    text: "Status",
    align: "center",
    formatter: (_, row) => {
      let backgroundColor, borderColor;

      switch (row.Status) {
        case "Em processamento":
          backgroundColor = "rgba(29, 119, 255, 0.1)";
          borderColor = "1px solid rgba(29, 119, 255, 0.5)";
          break;
        case "Disponível":
          backgroundColor = "rgba(0, 128, 0, 0.1)";
          borderColor = "1px solid rgba(0, 128, 0, 0.5)";
          break;
        case "Excluído":
          backgroundColor = "rgba(255, 56, 96, 0.1)";
          borderColor = "1px solid rgba(255, 56, 96, 0.5)";
          break;
        default:
          backgroundColor = "rgba(224, 224, 224, 0.1)";
          borderColor = "1px solid #cccccc";
      }
      return (
        <Chip
          label={row.Status}
          size="small"
          style={{
            width: "200px",
            padding: "1rem 0.5rem",
            backgroundColor: backgroundColor,
            border: borderColor,
          }}
        />
      );
    },
  }),
  columnTextField({
    dataField: "Download",
    text: "Download",
    align: "center",
    formatter: (_, row) => {
      return (
        <>
          {row.Status === "Disponível" ? (
            <Tooltip title="Download do relatório">
              <IconButton
                onClick={() => {
                  window.open(row.Download, "_blank");
                }}
              >
                <FileDownload />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Relatório não disponível">
              <IconButton onClick={() => {}}>
                <FileDownloadOff />
              </IconButton>
            </Tooltip>
          )}
        </>
      );
    },
  }),
];

export default function TableNfs({
  tableData,
  page,
  totalRegistros,
  onTableChange,
  sizePerPage,
  searching,
  reshearch,
}) {
  return (
    <Card>
      <CardContent>
        {searching ? (
          <LoadingData searching={true} label="Buscando dados..." />
        ) : (
          <TableComponent
            dataTable={tableData}
            columnModel={getColumnModel()}
            keyField="IdRelatorio"
            headerTitle={"Relatório de Notas Fiscais"}
            pagination={{
              options: [25, 50, 100],
              totalSize: totalRegistros,
              page: page + 1,
              sizePerPage: sizePerPage,
              showTotal: true,
            }}
            reshearch={reshearch}
            bootstrapTableProps={{
              remote: true,
              onTableChange: onTableChange,
            }}
            notFoundTitle="Sua pesquisa não encontrou nenhum relatório de notas fiscais."
          />
        )}
      </CardContent>
    </Card>
  );
}
